import { Injectable } from "@angular/core";
import { GridLayoutService } from "@irb/irb-common/interfaces/grid-layout.service";
import { SettingsSecuritiesComponent } from "./settings-securities.component";
import { UtilityService } from "@irb/irb-common/services/utility.service";
import { DeleteHeaderComponent } from "@irb/irb-common/components/grid/renderers/delete.header.component";
import { DeleteCellComponent } from "@irb/irb-common/components/grid/renderers/delete.cell.component";
import { ValidationTextBoxRendererComponent } from "@irb/irb-common/components/grid/renderers/validation-text-box-renderer.component";

@Injectable({
    providedIn: 'root'
})
export class SettingsSecuritesGridLayoutService implements GridLayoutService<SettingsSecuritiesComponent> {
    constructor(private util: UtilityService) {}

    getFrameworkComponents() {
        return {
            "DeleteHeaderComponent": DeleteHeaderComponent,
            "DeleteCellComponent": DeleteCellComponent,
            "ValidationTextBoxRendererComponent": ValidationTextBoxRendererComponent
        };
    }

    getColumnDefs(parent: SettingsSecuritiesComponent) {
        return [{
            headerName: 'Delete All',
            headerComponent: 'DeleteHeaderComponent',
            headerComponentParams: { 
                message: "Remove all menu choices?", 
                proceed: parent.checkCategoryRestrictions.bind(parent),
                cancel: parent.cancelDelete.bind(parent),
                disableDelete:!parent.isadmin
            },
            cellRenderer : 'DeleteCellComponent',
            cellRendererParams: { 
                message: "Remove this menu choice?",
                proceed: parent.checkDeleteCategory.bind(parent),
                cancel: parent.cancelDelete.bind(parent),
                disableDelete: parent.disableDelete.bind(parent),
               
            },
           
            resizable: false,
            maxWidth: 25,
            width: 25
        },
        {
            headerName: 'Category Name',
            field: 'valueLabel',
            sort: "asc",
            comparator: this.util.sortString.bind(parent),
            flex: 2,
            minWidth: 150,
            maxWidth: 220,
            cellClass: "validationTextBoxCell",
            cellRenderer: "ValidationTextBoxRendererComponent",
            cellRendererParams: (_params: any) => {
                return {
                    max: 25,
                    disabled: !(parent.isadmin && this.canEdit(_params)),
                    onChange: (params: any, c: any) => {
                        if (params.data.valueLabel !== c.value) {
                            params.data.valueLabel = c.value.trim();
                            params.api.redrawRows({ rowNodes: [params.node] });
                            parent.onGridChange(params);
                        }
                    }
                };
            }
        },
        {
            headerName: 'Category Description',
            field: 'categoryName',
            comparator: this.util.sortString.bind(parent),
            flex: 3,
            minWidth: 150,
            maxWidth: 630,
            cellClass: "validationTextBoxCell",
            cellRenderer: "ValidationTextBoxRendererComponent",
            cellRendererParams: (_params: any) => {
                return {
                    max: 50,
                    disabled: !(parent.isadmin && this.canEdit(_params)),
                    onChange: (params: any, c: any) => {
                        if (params.data.categoryName !== c.value) {
                            params.data.categoryName = c.value;
                            params.api.redrawRows({ rowNodes: [params.node] });
                            parent.onGridChange(params);
                        }
                    }
                };
            }
        },
        {
            headerName: 'Morningstar',
            field: 'isCustomEntry',
            valueGetter: (params: any) => {
                const a = params.data.valueLabel?.toUpperCase() == "CASH" || params.data.valueLabel?.toUpperCase() == "OTHER";
                const b = params.data.categoryName?.toUpperCase() == "CASH" || params.data.categoryName?.toUpperCase() == "OTHER";
                const c = params.data.isCustomEntry === true;
                return (a || b || c) ? "No" : "Yes";
            },
            minWidth: 100,
            maxWidth: 140,
            flex: 1
        },
        {
            headerName: 'Assigned Securities',
            field: 'customSecurityCount',
            minWidth: 160,
            maxWidth: 180,
            flex: 1,
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {
                link: (params: any) => {
                    return (params.value != null);
                },
                onClick: (function (data: any) {
                    parent.showSecurityDetails(data);
                }).bind(this)
            }
        }];
    }

    canEdit(params: any) {
        const a = params.data.valueLabel?.toUpperCase() == "CASH" || params.data.valueLabel?.toUpperCase() == "OTHER";
        const b = params.data.categoryName?.toUpperCase() == "CASH" || params.data.categoryName?.toUpperCase() == "OTHER";

        if(a || b) {
            params.data.isCustomEntry = false;
        }

        if(params.column.colId === "valueLabel" || params.column.colId === "categoryName") {
            return params.data.isCustomEntry;        
        }
    }
} 
